export const pinterest = {
  pinterest: {
    shape:
      '<path fill="#3d3d3d" d="M16.06 6.25c-5.5 0-10 4.5-10 10a9.92 9.92 0 0 0 6 9.13c0-.75 0-1.5.13-2.25.25-.88 1.25-5.5 1.25-5.5s-.38-.63-.38-1.63c0-1.5.88-2.63 1.88-2.63.87 0 1.37.63 1.37 1.5s-.62 2.26-.87 3.5c-.25 1 .5 1.88 1.62 1.88 1.88 0 3.13-2.38 3.13-5.38 0-2.24-1.5-3.87-4.13-3.87a4.7 4.7 0 0 0-4.87 4.75c0 .88.25 1.5.62 2 .13.25.25.25.13.5 0 .13-.13.63-.25.75-.13.25-.25.38-.5.25-1.38-.63-2-2.13-2-3.88 0-2.87 2.37-6.24 7.12-6.24 3.88 0 6.38 2.74 6.38 5.74 0 3.88-2.13 6.88-5.38 6.88a3.05 3.05 0 0 1-2.5-1.25l-.75 2.75c-.25.75-.62 1.5-1 2.13.88.25 1.88.37 2.88.37 5.5 0 10-4.5 10-10 .12-5-4.38-9.5-9.88-9.5z"/>',
    viewBox: [0, 0, 32, 32],
  },
};
